module.exports = __webpack_public_path__ + "img/img2.ca09fdb0.png";